export default "__VITE_ASSET__RwlIQLsU__"